import React from "react";

import ReactDOM from "react-dom";

import searchData from "../../config/searchData";
import { useScrollLock } from "../../hooks/useScrollLock";
import { MobileMenuHeader } from "../../styles/sharedStyles";

import {
  AllResults,
  Close,
  CustomButtonWrapper,
  IconSearch,
  InnerSearchContainer,
  ListItem,
  ResultLink,
  SearchBar,
  SearchBarContainer,
  SearchContainer,
  SearchText,
} from "./styles";

interface SearchPopupProps {
  searchQuery: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClose: () => void;
  visible: boolean;
}

export const SearchMenu: React.FC<SearchPopupProps> = ({
  searchQuery,
  onChange,
  onClose,
  visible,
}) => {

  useScrollLock(visible)
  if (!visible) return null;

  const overlayRoot = document.getElementById("overlay-root");

  if (!overlayRoot) return null;

  const filteredData = searchData.filter((item) =>
    item.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const content = (
    <SearchContainer>
      <MobileMenuHeader>
        <CustomButtonWrapper>
          <Close onClick={onClose} />
        </CustomButtonWrapper>
      </MobileMenuHeader>
      <InnerSearchContainer>
        <SearchText>Поиск</SearchText>
        <SearchBarContainer>
          <SearchBar
            type="text"
            placeholder="Введите запрос"
            value={searchQuery}
            onChange={onChange}
          />
          <IconSearch />
        </SearchBarContainer>
        {filteredData.length > 0 && (
          <AllResults>
            {filteredData.map((item, index) => (
              <ListItem key={index}>
                <ResultLink href={item.address}>
                  {item.title.toLowerCase()}
                </ResultLink>
              </ListItem>
            ))}
          </AllResults>
        )}
      </InnerSearchContainer>
    </SearchContainer>
  );

  return ReactDOM.createPortal(content, overlayRoot);
};

